import type { UserNotification } from '../../api/contracts'

const ALLOWED_PROTOCOLS = new Set(['http:', 'https:'])

function parseAppPath(url: string, origin: string): string | null {
  if (!url) {
    return null
  }
  try {
    const parsed = new URL(url, origin)
    if (!ALLOWED_PROTOCOLS.has(parsed.protocol) || !parsed.pathname.startsWith('/')) {
      return null
    }
    return `${parsed.pathname}${parsed.search}`
  } catch {
    return null
  }
}

/**
 * App path for `navigate`: the API sends an absolute link built from the public base URL (like e-mails) or an
 * empty string, so the host is dropped; without a usable link the request page is used, without a request `null`.
 */
export function resolveNotificationPath(
  notification: Pick<UserNotification, 'url' | 'requestId'>,
  origin: string = window.location.origin
): string | null {
  const path = parseAppPath(notification.url, origin)
  if (path) {
    return path
  }
  return typeof notification.requestId === 'number' ? `/requests/${notification.requestId}` : null
}
